import {ChangeDetectorRef, Component, Inject, OnInit, ViewRef} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConceptBrakedown, ReportsService} from '../../reports.service';
import {MessagingConstants} from '../../../../models/MessagingConstants';
import {Router} from '@angular/router';
import {MessagingService} from '../../../../services/messaging.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DatePipe, formatCurrency} from '@angular/common';
import {SignalrService} from '../../../../services/socket/signalr.service';
import {LocalStorageService} from '../../../../services/local-storage.service';
import {Globals} from '../../../../globals';
import * as XLSX from 'xlsx';
import Utils from '../../Utils/utils';
import {TdoTableFooterDataModel} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-footer-data.model';
import {ConversionUtilities} from '../../../../utilities/conversion.utilities';
import {DataRangesEnum} from '../../../../models/enum/Date-Ranges.enum';


export interface IParams {
    isProvider: boolean;
    PracticeId: number;
    DoctorId: string;
    LOCId: number;
    initialDate: string;
    endDate: string;
    ConceptBrakeDown: string;
    CurrentLocation: string;
}

@Component({
  standalone: false,
    selector: 'app-report-financial-snapshot-detail',
    templateUrl: './report-financial-snapshot-detail.component.html',
    styleUrls: ['./report-financial-snapshot-detail.component.scss']
})
export class ReportFinancialSnapshotDetailComponent implements OnInit {
    isLoading: boolean = false;
    conceptDetail: string;
    doctorID: any;
    LOCId: number;
    amount: any;
    isProvider: boolean;
    providerPracticeId: any;
    conceptBreakdownId: string;
    initialDate: string;
    endDate: string;
    conceptBreakdownDetails: ConceptBrakedown[];
    displayedData: ConceptBrakedown[];
    isCondensedView: boolean = false;
    parameters: IParams;
    searchPredicate: (data: any, filter: string) => boolean;
    sortPredicate: (data: any, sortHeaderId: string) => string;
    footerData: TdoTableFooterDataModel[];

    MTD: string = '000000000003';
    MTDCollection: string = '000000000018';
    Last_Year_MTD: string = '000000000004';
    Last_Year_MTDCollection: string = '000000000019';
    YTD: string = '000000000005';
    YTDCollection: string = '000000000020';
    Last_YTD: string = '000000000006';
    Last_YTDCollection: string = '000000000021';

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private service: ReportsService,
                private router: Router,
                private messagingService: MessagingService,
                private snackBar: MatSnackBar,
                private datePipe: DatePipe,
                private signalrService: SignalrService,
                private localStorageService: LocalStorageService,
                private globals: Globals,
                private cdr: ChangeDetectorRef) {
        this.searchPredicate = (searchData: ConceptBrakedown, filter: string) => {
            if ((!searchData.PatientName ? '' : searchData.PatientName).toLowerCase().includes(filter)) {
                return true;
            } else if ((!searchData.Tooth ? '' : searchData.Tooth).toLowerCase().includes(filter)) {
                return true;
            } else if ((!searchData.Code ? '' : searchData.Code).toLowerCase().includes(filter)) {
                return true;
            } else {
                return false;
            }
        };




    }

    ngOnInit(): void {
        this.isLoading = true;
        if (this.data) {
            this.parameters = {
                isProvider: this.data.isProvider,
                DoctorId: this.data.DoctorId,
                LOCId: this.data.LOCId,
                PracticeId: this.data.PracticeId,
                initialDate: this.data.initialDate,
                endDate: this.data.endDate,
                ConceptBrakeDown: this.data.ConceptBreakdownId,
                CurrentLocation: this.globals.LOCID
            };

            this.conceptDetail = this.data.ConceptDetail;
            this.amount = this.data.Amount;
            this.setDates(this.data.ConceptBreakdownId);

        }
        this.service.getConceptBrakdownDataSource(this.parameters).subscribe(response => {
            this.conceptBreakdownDetails = response;
            this.updateDisplayedData();
            // sort by Asc Date - sort from server
            //this.conceptBreakdownDetails.sort((a, b) => (a.Date > b.Date) ? 1 : -1);
            this.isLoading = false;
            if (!(this.cdr as ViewRef).destroyed) { this.cdr.detectChanges(); }
            // Add Footer Data
            this.AddFooterData();
        }, err => {
            this.showMessage('Error', 'Error getting reports');
            this.isLoading = false;
            if (!(this.cdr as ViewRef).destroyed) { this.cdr.detectChanges(); }
        });

        this.sortPredicate = (data: any, sortHeaderId: string) => {
            if (sortHeaderId === 'Amount') {
                return +data[sortHeaderId]; // Convert the value to a number for correct sorting
            }
            return data[sortHeaderId];
        };

    }

    setDates(ConceptBreakdownId: string) {
        let ConceptBreakdown: string;
        let isUtils: boolean;
        if (ConceptBreakdownId === this.MTD || ConceptBreakdownId === this.MTDCollection) {
            ConceptBreakdown = DataRangesEnum.Current;
            isUtils = true;
        } else if (ConceptBreakdownId === this.Last_Year_MTD || ConceptBreakdownId === this.Last_Year_MTDCollection) {
            ConceptBreakdown = DataRangesEnum.LastYear_MTD;
            isUtils = true;
        } else if (ConceptBreakdownId === this.Last_YTD || ConceptBreakdownId === this.Last_YTDCollection) {
            ConceptBreakdown = DataRangesEnum.LastYearYTD;
            isUtils = true;
        } else if (ConceptBreakdownId === this.YTD || ConceptBreakdownId === this.YTDCollection) {
            ConceptBreakdown = DataRangesEnum.CurrentYear;
            isUtils = true;
        } else {
            this.initialDate = this.datePipe.transform(this.data.initialDate, 'shortDate');
            this.endDate = this.datePipe.transform(ConversionUtilities.convertUTCDateToLocalDateFromString(this.data.endDate), 'shortDate');
            isUtils = false;
        }
        if (isUtils) {
            const {startDate, endDate} = Utils.getDataRange(ConceptBreakdown);
            this.initialDate = this.datePipe.transform(startDate, 'shortDate');
            this.endDate = this.datePipe.transform(endDate, 'shortDate');
        }
    }

    showMessage(type, message) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    /**
     * Footer cells are matched to columns by index, so the footer has to follow the same column
     * set the template projects for the current view.
     */
    getDisplayedColumnNames(): string[] {
        return this.isCondensedView
            ? ['No', 'PatientNO', 'PatientName', 'Amount', 'PatientId']
            : ['No', 'PatientNO', 'PatientName', 'Tooth', 'Code', 'ReferringDoctor', 'Date', 'Amount', 'Comments', 'PatientId'];
    }

    AddFooterData() {
        const columnNames = this.getDisplayedColumnNames();
        this.footerData = columnNames.map(() => new TdoTableFooterDataModel());

        const amountColumnIndex = columnNames.indexOf('Amount');

        const TotalFooterLabel = new TdoTableFooterDataModel();
        TotalFooterLabel.value = 'Total:';
        //TotalFooterLabel.tdStyle = 'text-align: end';

        const TotalFooterData = new TdoTableFooterDataModel();
        TotalFooterData.value = this.amount;
        //TotalFooterData.tdStyle = 'text-align: end';

        this.footerData[amountColumnIndex - 1] = TotalFooterLabel;
        this.footerData[amountColumnIndex] = TotalFooterData;
    }

    updateDisplayedData(): void {
        this.displayedData = this.isCondensedView
            ? this.getCondensedData(this.conceptBreakdownDetails)
            : this.conceptBreakdownDetails;
    }

    /**
     * The API sends `Amount` as a string even though the model declares it a number, so it has to
     * be coerced before summing — otherwise `+` concatenates and the currency pipe rejects the
     * result, leaving the amount cell blank.
     */
    private toNumericAmount(amount: number): number {
        const numericAmount = Number(amount);
        return Number.isFinite(numericAmount) ? numericAmount : 0;
    }

    getCondensedData(details: ConceptBrakedown[]): ConceptBrakedown[] {
        if (!details) {
            return details;
        }
        const groupedByPatient = new Map<string, ConceptBrakedown>();
        details.forEach(item => {
            const existing = groupedByPatient.get(item.PatientId);
            if (existing) {
                existing.Amount += this.toNumericAmount(item.Amount);
            } else {
                groupedByPatient.set(item.PatientId, {
                    PatientId: item.PatientId,
                    PatientNO: item.PatientNO,
                    PatientName: item.PatientName,
                    Tooth: '',
                    Code: '',
                    ReferringDoctor: '',
                    Date: '',
                    Amount: this.toNumericAmount(item.Amount),
                    Comments: ''
                });
            }
        });
        return Array.from(groupedByPatient.values());
    }

    onCondensedViewChange(): void {
        this.updateDisplayedData();
        this.AddFooterData();
        if (!(this.cdr as ViewRef).destroyed) { this.cdr.detectChanges(); }
    }


    openLedger(model: any) {
        const payload = {
            messageType: MessagingConstants.PATIENT_CHANGE_STARTLEDGER,
            PatientID: model.PatientId,
            PatientName: model.PatientName
        };
        if (window.opener) {
            // Report is running in a popup — relay directly to the parent window
            window.opener.postMessage(payload, window.location.origin);
        } else {
            this.signalrService.messageSingleUser(
                this.localStorageService.currentUserData.authdata.userid,
                MessagingConstants.PATIENT_CHANGE_STARTLEDGER,
                { PatientID: model.PatientId, PatientName: model.PatientName }
            );
        }
        // move window and resize it
        window.resizeTo((screen.width * .65), (screen.height * .80));
        if (window.screen.width > 1560) {
            window.moveBy((screen.width * .65), (screen.height * .25));
        } else {
            window.moveBy((screen.width * .35), (screen.height * .25));
        }
    }

    onRowSelected(event: any) {
    }

    exportToExcel(): void {
        const data = this.displayedData.map(item =>
            ({
                PatientNo: item.PatientNO,
                Patient: item.PatientName,
                Tooth: item.Tooth,
                Code: item.Code,
                ReferringDoctor: item.ReferringDoctor,
                Date: {v: item.Date ? new Date(item.Date.split('T')[0] + 'T00:00:00') : null, t: 'd', z: 'mm/dd/yyyy'},
                Amount: {v: item.Amount, t: 'n', z: '$#,##0.00'},
                Comments: item.Comments

            })
        );
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data, {
            header: ['PatientNo','Patient', 'Tooth', 'Code', 'ReferringDoctor', 'Date', 'Amount', 'Comments'],
            skipHeader: false
        });
        const wb: XLSX.WorkBook = {Sheets: {data: ws}, SheetNames: ['data']};
        const excelBuffer: any = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
        Utils.saveExcelFile(excelBuffer, this.conceptDetail + '_data.xlsx');
    }
}
